var exports = {
  "l0": "xf0b3b88a--5a1ee1--recidivist",
  "Hk": "xf0b3b88a--5a1ee1--excluded-from-action",
  "B5": "xf0b3b88a--5a1ee1--svg-container",
  "eb": "xf0b3b88a--5a1ee1--recidivist-description",
  "nf": "xf0b3b88a--5a1ee1--link",
  "U4": "xf0b3b88a--5a1ee1--complaint",
};

module.exports = exports;
